// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
  OVERVIEW: "/overview",
  USER: "/user",
  MANAGEMENT: "/management",
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    standard: {
      login: `${ROOTS.AUTH}/login`,
    },
  },
  // -------------------------------------------- overview routes --------------------------------------------
  overview: {
    dashboard: {
      root: `${ROOTS.OVERVIEW}/dashboard`,
    },
    challengeSuggestions: {
      root: `${ROOTS.OVERVIEW}/challenge-suggestions`,
    },
    storyReports: {
      root: `${ROOTS.OVERVIEW}/story-reports`,
    },
    chat: {
      root: `${ROOTS.OVERVIEW}/chat`,
    },
  },
  // -------------------------------------------- user routes --------------------------------------------
  user: {
    children: {
      root: `${ROOTS.USER}/childrens`,
    },
    parent: {
      root: `${ROOTS.USER}/parents`,
    },
    admin: {
      root: `${ROOTS.USER}/admins`,
    },
    userReports: {
      root: `${ROOTS.USER}/user-reports`,
    },
  },
  // -------------------------------------------- management routes --------------------------------------------
  management: {
    category: {
      root: `${ROOTS.MANAGEMENT}/categories`,
    },
    challenge: {
      root: `${ROOTS.MANAGEMENT}/challenges`,
    },
    challengeUserReports: {
      root: `${ROOTS.MANAGEMENT}/challenge-user-reports`,
    },
    badge: {
      root: `${ROOTS.MANAGEMENT}/badges`,
    },
    award: {
      root: `${ROOTS.MANAGEMENT}/awards`,
      // new: `${ROOTS.MANAGEMENT}/awards/new`,
      // list: `${ROOTS.MANAGEMENT}/awards/list`,
      // cards: `${ROOTS.MANAGEMENT}/awards/cards`,
      // edit: (id: string) => `${ROOTS.MANAGEMENT}/awards/${id}/edit`,
      // create: `${ROOTS.MANAGEMENT}/awards/create`,
    },
    step: {
      root: `${ROOTS.MANAGEMENT}/steps`,
      new: `${ROOTS.MANAGEMENT}/steps/new`,
      list: `${ROOTS.MANAGEMENT}/steps/list`,
      cards: `${ROOTS.MANAGEMENT}/steps/cards`,
      edit: (id: string) => `${ROOTS.MANAGEMENT}/steps/${id}/edit`,
      create: `${ROOTS.MANAGEMENT}/steps/create`,
    },
    activity: {
      root: `${ROOTS.MANAGEMENT}/activities`,
    },
  },
};
